/* import __COLOCATED_TEMPLATE__ from './workflow-link.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnly from '@ember/component/template-only';
import { type ButtonType } from '@intercom/pulse/template-registry';

export interface StandaloneWorkflowLinkArgs {
  workflowId: string | number;
  route: string;
  title: string;
  isLoading?: boolean;
  isFinEnabled?: boolean;
  buttonType?: ButtonType;
}

let StandaloneWorkflowLink = templateOnly<StandaloneWorkflowLinkArgs>();

export default StandaloneWorkflowLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::WorkflowLink': typeof StandaloneWorkflowLink;
  }
}
